import { Loader } from "@googlemaps/js-api-loader";
import { COUNTRY_CODE } from "./constants";

const map_styles = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#242f3e",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#746855",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#242f3e",
      },
    ],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563",
      },
    ],
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#263c3f",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6b9a76",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#38414e",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#212a37",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9ca5b3",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#746855",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#1f2835",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#f3d19c",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#2f3948",
      },
    ],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#17263c",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#515c6d",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#17263c",
      },
    ],
  },
];

export interface Suggestion
  extends google.maps.places.QueryAutocompletePrediction {
  structured_formatting: {
    main_text: string;
    secondary_text: string;
  };
}

export const queryAutoCompleteService = (
  query: string,
  handleSuggestions: (
    predictions: Suggestion[] | null,
    status: google.maps.places.PlacesServiceStatus
  ) => void
) => {
  const loader = new Loader({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY || "",
    version: "weekly",
    libraries: ["places"],
  });

  loader
    .importLibrary("places")
    .then((val) => {
      const sessionToken = new val.AutocompleteSessionToken();
      const service = new val.AutocompleteService();

      service.getPlacePredictions(
        {
          input: query,
          sessionToken: sessionToken,
          componentRestrictions: { country: COUNTRY_CODE || "nz" },
        },
        handleSuggestions
      );
    })
    .catch((e) => {
      console.error(e);
    });
};

export const getDetails = (placeId: any, callback: any) => {
  const loader = new Loader({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY || "",
    version: "weekly",
    libraries: ["places"],
  });

  loader.importLibrary("places").then((place) => {
    const request = {
      placeId: placeId,
      fields: ["address_component", "geometry", "name", "type"],
    };

    const service = new place.PlacesService(document.createElement("div"));
    service.getDetails(request, callback);
  });
};

export async function getMap(
  map_ref: HTMLDivElement,
  lat: number,
  lng: number
) {
  const loader = new Loader({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "",
    version: "weekly",
  });

  loader.load().then(async () => {
    let map = new google.maps.Map(map_ref, {
      center: { lat, lng },
      zoom: 15,
      styles: map_styles,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    new google.maps.Marker({
      map: map,
      position: { lat, lng },
    });
  });
}
